import { getAuthAxiosBackend } from "../../helpers/axios"

class MartyrServices{

    get(id){
        return getAuthAxiosBackend().get('housing-units/martyrs/'+id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('housing-units/martyrs', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('housing-units/martyrs/' + id)
    }
}

export default new MartyrServices()